<div class="content-wrapper" style="margin-bottom: 100px">
  <div class="col-md-12 layout-spacing" style="margin-top: 30px">
    <div class="row">
      <div class="col-md-4">
        <div class="card">
          <img
            class="card-img-top img-fluid"
            src="assets/img/ComplianceManager.png"
            alt="Card image cap"
          />
          <div class="card-body card-btns">
            <a
              href="https://purview.microsoft.com/compliancemanager/overviewpage"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: fit-content"
              >{{ 'dataClasification.dashboard' | translate }}</a
            >
            <a
              href="https://purview.microsoft.com/compliancemanager/improvementactionspage"
              target="_blank"
              class="btn btn-primary btn-rounded"
              style="width: fit-content"
              >{{ 'confidentialityLabels.improvementActions' | translate }}</a
            >
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="card text-white bg-pink text-xs-center"
          style="height: 100%"
        >
          <div class="card-body" style="padding: 1.9rem">
            <h3 style="font-size: 1.5rem">
              <strong>{{ 'confidentialityLabels.title' | translate }}</strong>
            </h3>
            <blockquote class="card-bodyquote">
              <p style="font-size: 1rem" class="mb-3 mt-3">
                {{ 'confidentialityLabels.section1' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'confidentialityLabels.section2' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'confidentialityLabels.section3' | translate }}
              </p>
              <p style="font-size: 1rem" class="mb-3">
                {{ 'confidentialityLabels.section4' | translate }}
              </p>
            </blockquote>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
